<template>
  <footer class="footer"></footer>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>

<style lang="scss">
@import '../../../node_modules/bulma/sass/utilities/mixins';

.footer {
  margin-left: 180px;

  @include mobile() {
    margin-left: 0;
  }

  .social a {
    border-bottom: none !important;
  }

  .fa.fa-heart {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// FooterBar.vue?33e0c414